import * as  React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import ProjectsTable from '../ProjectsTable/ProjectsTable';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import * as actions from '../../../../redux/projects/actions.projects';
import * as userActions from '../../../../redux/user/actions.user';
import getPageTitle from '../../../../services/mini/getPageTitle';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import PlaygroundAppTile from '../PlaygroundAppTile/PlaygroundAppTile';
import ProjectsHeader from '../ProjectsHeader/ProjectsHeader';
import { IStore } from '../../../../redux/initialState';

const NoProjectsView = React.lazy(() => import('../NoProjectsView/NoProjectsView'));

class ProjectsPage extends React.Component<ProjectsPageReduxProps> {

    updateBalanceInterval = null;

    constructor(props) {
        super(props);

        this.updateBalanceInterval = null;
    }

    componentDidMount() {
        document.title = getPageTitle('Projects');

        this.updateBalanceInterval = setInterval(() => {
            this.props.getUserBalance();
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.updateBalanceInterval);
    }

    render() {
        const {
            projects,
            hasProjectsData,
            isProjectCreating,
            isProjectDeleting,
            isImportingScriptsInProgress,
            user
        } = this.props;

        return <div className="projects-page">
            <MainHeader>
                <ProjectsHeader />
            </MainHeader>
            <div className="projects-page_projects">
                {hasProjectsData ?
                    <>{
                        projects.length > 0 ?
                            <>
                                <PlaygroundAppTile />
                                <ProjectsTable />
                            </> :
                            <React.Suspense fallback={<Loader theme={LoaderTheme.Light} size={LoaderSize.Big} />}>
                                <NoProjectsView
                                    projects={projects}
                                    user={user}
                                    addNewProject={this.props.addNewProject} />
                            </React.Suspense>
                    }
                    </> :
                    <div className="projects-page_projects_loading">
                        <Loader theme={LoaderTheme.Light} size={LoaderSize.Big} />
                    </div>
                }
                {(isProjectCreating || isProjectDeleting || isImportingScriptsInProgress) && <div className="projects-page_saving-overlay">
                    <Loader theme={LoaderTheme.Light} size={LoaderSize.Big} />
                </div>}
            </div>
        </div>;
    }
}

function mapStateToProps({ projectsInfo, user }: IStore, ownProps) {
    return {
        projects: projectsInfo.projects,
        hasProjectsData: projectsInfo.hasProjectsData,
        isProjectCreating: projectsInfo.isProjectCreating,
        isProjectDeleting: projectsInfo.isProjectDeleting,
        isImportingScriptsInProgress: projectsInfo.currentProject.isImportingScriptsInProgress,
        userEmail: user.email,
        user: user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addNewProject: (param) => asyncDispatch(actions.addNewProject, dispatch, param),
        reorderProjects: (param) => dispatch(actions.reorderProjects(param)),
        getUserBalance: () => dispatch(userActions.getUserBalance()),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type ProjectsPageReduxProps = ConnectedProps<typeof connector>;

export default connector(ProjectsPage);